<script setup lang="ts">
import { useDark, useToggle } from '@vueuse/core'

const isDark = useDark({
  selector: 'html',
  attribute: 'data-theme',
  valueDark: 'dark',
  valueLight: 'light',
  initialValue: 'light',
  storageKey: 'theme',
})

const toggleDark = useToggle(isDark)
</script>
<template>
  <label class="tw-daisy-swap tw-daisy-swap-rotate">
    <input
      :checked="isDark"
      id="changeTheme"
      type="checkbox"
      value="dark"
      class="theme-controller"
      @change="toggleDark()"
    />

    <!-- sun icon -->
    <div class="tw-flex tw-items-center tw-justify-center tw-daisy-swap-on">
      <span class="material-symbols-outlined tw-text-4xl" translate="no">
        light_mode
      </span>
    </div>

    <!-- moon icon -->
    <div class="tw-flex tw-items-center tw-justify-center tw-daisy-swap-off">
      <span class="material-symbols-outlined tw-text-4xl" translate="no">
        dark_mode
      </span>
    </div>
  </label>
</template>
